import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import TopNavigation from '@cloudscape-design/components/top-navigation';
import Modal from '@cloudscape-design/components/modal';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Link from '@cloudscape-design/components/link';
import LandingPage from './pages/LandingPage';
import MetricsRecommenderPage from './pages/MetricsRecommenderPage';
import ThresholdAnalysisPage from './pages/ThresholdAnalysisPage';

const AppContent: React.FC = () => {
  const navigate = useNavigate();
  const [contactVisible, setContactVisible] = useState(false);

  return (
    <>
      <TopNavigation
        identity={{
          href: '/',
          title: 'Metrics Insight AI',
          onFollow: (e) => { e.preventDefault(); navigate('/'); },
        }}
        utilities={[
          {
            type: 'button',
            iconName: 'envelope',
            text: 'Contact Us',
            onClick: () => setContactVisible(true),
          },
        ]}
      />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/metrics-recommender" element={<MetricsRecommenderPage />} />
        <Route path="/threshold-analysis" element={<ThresholdAnalysisPage />} />
      </Routes>
      <Modal
        visible={contactVisible}
        onDismiss={() => setContactVisible(false)}
        header="Contact Us"
      >
        <SpaceBetween size="l">
          <SpaceBetween size="m" direction="horizontal">
            <div style={{ textAlign: 'center' }}>
              <img
                src="/photos/saratrag.jpg"
                alt="saratrag"
                style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', border: '2px solid #555' }}
              />
              <Box display="block" margin={{ top: 'xs' }}>
                <Link href="https://phonetool.amazon.com/users/saratrag" external>saratrag</Link>
              </Box>
            </div>
            <div style={{ textAlign: 'center' }}>
              <img
                src="/photos/samasamb.jpg"
                alt="samasamb"
                style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', border: '2px solid #555' }}
              />
              <Box display="block" margin={{ top: 'xs' }}>
                <Link href="https://phonetool.amazon.com/users/samasamb" external>samasamb</Link>
              </Box>
            </div>
          </SpaceBetween>
        </SpaceBetween>
      </Modal>
    </>
  );
};

const App: React.FC = () => (
  <BrowserRouter>
    <AppContent />
  </BrowserRouter>
);

export default App;
